import { featuresService } from '../../../../App';
import { FeatureTypes } from '../../../../services/feature-service/features.enum';
import { getCurrentUserUrl } from '../../../../global-helpers/global.helpers';
import BlockModel from '../../../Partials/Blocky/models/block.model';
import Article from '../../../../models/article/Article';
import { IAiAssistantContent, IAiAssistantExtractedContent } from '../models/ai-assistant.models';

export const isAiToolsEnabled = () => {
	return featuresService.checkFeatureIsSetAndEnabled(FeatureTypes.AI_TOOLS);
};

export const getAiToolsConfig = () => {
	return featuresService.getFeatureConfig(FeatureTypes.AI_TOOLS);
};

export const isArticleScreen = (currentUrl: string = getCurrentUserUrl()): boolean => {
	return currentUrl.includes('/smp/articles/edit') || currentUrl.includes('/smp/articles/create');
};

export const isArticleEdit = (currentUrl: string = getCurrentUserUrl()): boolean => {
	return currentUrl.includes('/smp/articles/edit');
};

export const extractCleanBodyText = (body: BlockModel[]): string => {
	if (!Array.isArray(body)) return '';

	return body
		.filter((block) => block && block.data && block.data.type === 'paragraph')
		.map((block) => {
			const content = (block && block.data && block.data.content) || '';
			return content.replace(/<\/?p>/g, '').trim();
		})
		.filter(Boolean)
		.join(' ');
};

export const hasBodyText = (article: Article) => {
	return !(
		article.body &&
		article.body.length > 0 &&
		article.body.some(function (block: BlockModel) {
			if (!block.data || !block.data.content) {
				return false;
			}

			const content = block.data.content.trim();
			// Check if content is NOT empty and NOT just an empty <p></p> tag
			return content.length > 0 && !/^<p>\s*<\/p>$/.test(content);
		})
	);
};

export const hasValidExtractedContent = (
	aiAssistantContent: IAiAssistantContent,
	field: 'main_title' | 'summary' | 'seo_title',
): boolean => {
	return (
		aiAssistantContent !== null &&
		aiAssistantContent[field] !== null &&
		Array.isArray(aiAssistantContent[field].extracted_content) &&
		aiAssistantContent[field].extracted_content.length > 0
	);
};

export const resolveContentValue = (aiFieldContent: IAiAssistantExtractedContent | null, articleFallbackValue: string) => {
	return (aiFieldContent && aiFieldContent.current_content) || articleFallbackValue || '';
};
